"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _Dialog = _interopRequireDefault(require("../components/Dialog"));

var _messageActions = require("../actions/messageActions");

var _Button = _interopRequireDefault(require("../components/Button"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MessageDialog = function MessageDialog(props) {
  var stateMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.messageReducer.errorMessage;
  });
  var dispatch = (0, _reactRedux.useDispatch)();
  var history = (0, _reactRouter.useHistory)();
  var message = props.message ? props.message : stateMessage;

  if (!message) {
    return /*#__PURE__*/_react.default.createElement("div", {
      hidden: true
    }, "\xA0");
  }

  if (message && message.fullScreen) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      classNames: ['return-button', 'error-refresh'],
      onClick: function onClick() {
        return history.go(0);
      }
    }, "Refresh");
  }

  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    title: 'Error',
    onClose: function onClose() {
      if (dispatch) {
        dispatch({
          type: _messageActions.HIDE_MESSAGE
        });
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'error-body'
  }, /*#__PURE__*/_react.default.createElement("span", null, message === null || message === void 0 ? void 0 : message.message)));
};

MessageDialog.propTypes = {
  message: _propTypes.default.any
};
var _default = MessageDialog;
exports.default = _default;